import { render } from "./list-item-image.vue?vue&type=template&id=43c617c0&scoped=true"
import script from "./list-item-image.vue?vue&type=script&lang=js"
export * from "./list-item-image.vue?vue&type=script&lang=js"

import "./list-item-image.vue?vue&type=style&index=0&id=43c617c0&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c617c0"]])

export default __exports__